import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import menuItemsReducer from "../features/menuItems/menuItemsSlice";
import categoriesReducer from "../features/categories/categoriesSlice";
import brandsReducer from "../features/brands/brandsSlice";
import relatedProductsReducer from "../features/relatedProducts/relatedProductSlice";
import cardReducer from "../features/card/cardSlice";
import patientReducer from "../features/patient/patientSlice";
import promoCodesReducer from "../features/promoCodes/promoCodeSlice";
import shopDetailsReducer from "../features/shopDetails/shopDetailsSlice"
import favoritesReducer from "../features/favorites/favoritesSlice";
import reviewsReducer from "../features/reviews/reviewsSlice";
import ordersReducer from "../features/orders/ordersSlice";
import orderChatReducer from "../features/orderChat/orderChatSlice";
import notificationsReducer from "../features/notifications/notificationsSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    menuItems: menuItemsReducer,
    categories: categoriesReducer,
    brands: brandsReducer,
    relatedProducts: relatedProductsReducer,
    card: cardReducer,
    patient: patientReducer,
    promoCodes: promoCodesReducer,
    shopDetails: shopDetailsReducer,
    favorites: favoritesReducer,
    reviews: reviewsReducer,
    orders: ordersReducer,
    orderChat: orderChatReducer,
    notifications: notificationsReducer,
  },
});
